import {push} from 'react-router-redux'
import {appUrl} from '../core/locationz'

export function unauthorized(loginPath) {
    return ({dispatch, getState}) => {
        return (next) => (action) => {
            if (typeof action.error == 'object' && action.error.statusCode == 401) {
                // go to login page
                const state = getState()
                const {location} = state.router
                
                const history = [{
                    pathname: location.pathname,
                    search: location.search
                }]

                // reload to discard app state
                // keep current location to go back after login
                const encodedState = btoa(JSON.stringify({router: {history}}))
                window.location = appUrl(loginPath, {state: encodedState})

                dispatch(push(loginPath))
                return next(action)
            }
            return next(action)
        }
    }
}


// WEBPACK FOOTER //
// ./lib/user/middlewares.js